import { GRAY_700, GRAY_900 } from 'constants/styling/theme'
import { Stack, Typography } from '@mui/material'

import { FilterTab } from 'components/common/FilterTab'
import { MessageThreadDTO } from 'models/messageThreads'
import React from 'react'
import { SectionedBorderBox } from 'components/common/SectionedBorderBox'
import { ThreadStatusBadge } from 'components/common/Threads/Thread/ThreadStatusBadge.component'
import { useTranslation } from 'react-i18next'

/** @interface Props for the ClientGalleryRequestThreadList component. */
interface Props {
  /** Array of message thread items. */
  threadMessageItems?: MessageThreadDTO[]
  /** Currently selected thread, or null if none is selected. */
  selectedThread?: MessageThreadDTO | null
  /** Callback function to set the selected thread. */
  setSelectedThread: (thread: MessageThreadDTO | null) => void
}

/**
 * ClientGalleryRequestThreadList component displays a list of request threads for the client gallery.
 *
 * @example <ClientGalleryRequestThreadList />
 */
export const ClientGalleryRequestThreadList: React.FC<Props> = ({
  threadMessageItems = [],
  setSelectedThread,
  selectedThread
}) => {

  const { t } = useTranslation(['threads'])

  return (
    <SectionedBorderBox
      title={
        <Typography color={GRAY_900} variant="text-lg" fontWeight={600}>
          {t('thread_list_title')}
        </Typography>
      }
      minWidth="26rem"
      flexShrink={0}
    >
      <Stack gap=".8rem">

        {threadMessageItems.map((threadData, index) => {
          const isSelected = selectedThread?.id === threadData.id

          return (
            <FilterTab
              key={threadData.id}
              isActive={isSelected}
              height="4rem"
              label={
                <Typography
                  variant="text-sm"
                  color={isSelected ? GRAY_900 : GRAY_700}
                  sx={{
                    display: 'inline-block',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    maxWidth: '16rem',
                    textOverflow: 'ellipsis',
                  }}
                  title={threadData.title}
                >
                  {threadData.title}
                </Typography>
              }
              onClick={() => setSelectedThread(threadData)}
              badge={<ThreadStatusBadge status={threadData.state} />}
            />
          )
        })}

      </Stack>

    </SectionedBorderBox>
  )
}
